export default __webpack_public_path__ + "static/media/googlechrome.301ac7ab.png";